import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminResponsibleComponent } from './admin-responsible.component';
import { SharedModule } from '@shared/shared.module';
import { AdminResponsibleItemComponent } from './components/admin-responsible-item/admin-responsible-item.component';
import { AdminResponsibleInfoComponent } from './components/admin-responsible-info/admin-responsible-info.component';
import { AdminResponsibleCreateComponent } from './components/admin-responsible-create/admin-responsible-create.component';
import { AdminResponsibleEditComponent } from '@app/main/admin/modules/admin-responsible/components/admin-responsible-edit/admin-responsible-edit.component';

@NgModule({
    declarations: [
        AdminResponsibleComponent,
        AdminResponsibleItemComponent,
        AdminResponsibleInfoComponent,
        AdminResponsibleCreateComponent,
        AdminResponsibleEditComponent
    ],
    exports: [AdminResponsibleComponent],
    imports: [CommonModule, SharedModule]
})
export class AdminResponsibleModule {}
